var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioFalse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.375C15.6075 3.375 12.7799 4.23274 10.3748 5.83976C7.96972 7.44677 6.0952 9.73088 4.98827 12.4033C3.88134 15.0756 3.59171 18.0162 4.15602 20.8532C4.72033 23.6902 6.11323 26.2961 8.15857 28.3414C10.2039 30.3868 12.8098 31.7797 15.6468 32.344C18.4838 32.9083 21.4244 32.6187 24.0968 31.5117C26.7691 30.4048 29.0532 28.5303 30.6602 26.1252C32.2673 23.7201 33.125 20.8926 33.125 18C33.1209 14.1225 31.5788 10.4049 28.8369 7.66309C26.0951 4.92125 22.3775 3.37909 18.5 3.375ZM18.5 30.375C16.0525 30.375 13.6599 29.6492 11.6248 28.2894C9.58977 26.9297 8.00363 24.9969 7.067 22.7357C6.13036 20.4745 5.8853 17.9863 6.36279 15.5858C6.84028 13.1852 8.01889 10.9802 9.74956 9.24955C11.4802 7.51888 13.6852 6.34027 16.0858 5.86278C18.4863 5.38529 20.9745 5.63036 23.2357 6.56699C25.497 7.50363 27.4297 9.08976 28.7894 11.1248C30.1492 13.1599 30.875 15.5525 30.875 18C30.8713 21.2809 29.5663 24.4264 27.2463 26.7463C24.9264 29.0663 21.7809 30.3713 18.5 30.375Z",
    fill: "#005754",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioFalse);
export default __webpack_public_path__ + "static/media/RadioFalse.9d860de51f2e7cf380786918d61b2dc4.svg";
export { ForwardRef as ReactComponent };